import axios from 'axios';
import { extractApiArray } from '../utils/apiResponse';

const headers = () => ({ Authorization: localStorage.getItem('token') });
const statusValue = status => status?.databaseValue ?? status;

export async function searchTransferOrders(search, sourceOrderId, signal) {
  const query = search.trim();
  const id = query.match(/^#?\s*(\d+)$/);
  if (id && (!Number.isSafeInteger(Number(id[1])) || Number(id[1]) > 2147483647))
    throw new Error('Введіть коректний номер замовлення');
  const response = await axios.get('/api/v1/order', {
    headers: headers(),
    signal,
    params: {
      numberPerPage: 10,
      page: 1,
      orderStatusList:
        'NEW,HOLD,PREORDER,PREORDER_DELIVERY_CONFIRMED,PREORDER_AWAITING_SHIPMENT_CONFIRM,WAITING_FOR_PACKAGING,WAITING_FOR_SENDING,SENT',
      ...(id ? { orderId: Number(id[1]) } : query ? { clientSurname: query } : {}),
    },
  });
  return extractApiArray(response).filter(
    order =>
      Number(order.orderId) !== Number(sourceOrderId) &&
      !['CANCELLED', 'RETURNED'].includes(statusValue(order.orderStatus)),
  );
}

export function transferOrderItems(sourceOrderId, items, targetOrderId, targetOrderStatus = 'NEW') {
  const split = targetOrderId == null;
  return axios.post(
    `/api/v1/order/${sourceOrderId}/items/${split ? 'split' : 'move'}`,
    {
      items,
      ...(split ? { targetOrderStatus } : { targetOrderId }),
    },
    { headers: headers() },
  );
}

export function mergeOrders(orderIds, confirmPromPaymentRisk = false) {
  return axios.post('/api/v1/order/merge', { orderIds, confirmPromPaymentRisk }, { headers: headers() });
}
